//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Mannheim',
  data() {
    return {
      form: {
        gender: '',
        ageOver50: '0',
        organFailure: '0',
        malignancy: '0',
        preop: '0',
        origin: '0',
        diffuse: '0',
        exsudate: '',
      },
      hasScore: false,
      disabled: false,
      defaultJson: {
        "Malignancy": "恶性肿瘤",
        "Diffuse Generalized Peritonitis": "弥漫性全腹膜炎",
        "Exudate": "腹腔渗出物",
        "Clear": "透亮",
        "Origin of Sepsis not Colonic": "败血症病因非慢性",
        "Low risk of death": "死亡低危",
        "Cloudy": "絮状",
        "Pre-op peritonitis > 24 hours": "术前腹膜炎持续24h以上",
        "High risk of death": "死亡高危",
        "Organ Failure": "器官功能衰竭",
        "Moderate risk of death": "死亡中危",
        "Fecal": "粪质性",
        "orgFailureHintText": "定义为：\n• 肌酐 > 2 mg\/dL（177 μmol\/L）\n• 无尿 < 20 mL\/h\n• pO2 < 50 mmHg（6.7 kPa）\n• pCO2 > 50 mmHg（6.7 kPa）\n• 休克\n• 肠梗阻（肠麻痹 > 24h\n或完全性机械性肠梗阻）",
        "Age > 50 years": "年龄 > 50 岁"
      },
      dataList1: [
        { value: "0", name: '男' },
        { value: "5", name: '女' },
      ],
      dataList2: [
        { value: "0", name: '透亮' },
        { value: "6", name: '絮状' },
        { value: "12", name: '粪质性' },
      ],
      major: 0,
      minor: 0
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // (ageOver50 ? 5 : 0) + (gender.isFemale ? 5 : 0) + (organFailure ? 7 : 0) + (malignancy ? 4 : 0) + (preop ? 4 : 0) + (origin ? 4 : 0) + (diffuse ? 6 : 0) + exsudate
        let result = (form.ageOver50 ? 5 : 0) + form.gender + (form.organFailure ? 7 : 0) + (form.malignancy ? 4 : 0) + (form.preop ? 4 : 0) + (form.origin ? 4 : 0) + (form.diffuse ? 6 : 0) + form.exsudate
        return String(result)
      }


    },
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Mannheim.vue